import styled from 'styled-components';
import { baseVariables } from '../../styles/baseVariables';

const spacer02 = baseVariables.spacers?.spacers?.[2] ?? '0.5rem';
const spacer03 = baseVariables.spacers?.spacers?.[3] ?? '1rem';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacer03};
`;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${spacer02};
`;

export const ListItem = styled.li`
  display: flex;
`;
